import FileHelper from "../../shared/helper/FileHelper";
import validator from "validator";
import Downloader from "../document/Downloader";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class DownloadManager {
	public async downloadUrl(url: string, filename: string): Promise<any> {
		if (!validator.isURL(url)) {
			return;
		}

		await FileHelper.download([{
			name: FunctionHelper.applyValue(filename, "unknown"), url: url + '#pdfjs.action=download'
		}]);
	}

	public async downloadData(data: BlobPart, filename: string, contentType: string): Promise<any> {
		let downloader: Downloader = new Downloader();
		await downloader.downloadData(data, filename, contentType);
	}

	public async download(blob: Blob, url: string, filename: string): Promise<any> {
		let downloader: Downloader = new Downloader();
		await downloader.download(blob, filename);
	}
}